module.exports = __webpack_public_path__ + "static/Nightmare-8a781e0532723baa1b9f036486d675a1.jpg";